<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-text>
        <h3 class="headline mb-0">{{ $t("categories.title") }}</h3>
        <v-form ref="form">
          <v-select :items="applicationTypes" item-text="name" item-value="id" v-model="model.applicationType" />
          <v-text-field v-model="model.order" :label="this.$t('categories.order')" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="this.save" color="success">
          {{ $t("ctrl.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VAlert,
    VDialog
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'

  export default {
    name: 'Category',
    data: () => ({
      dialog: false,
      model: {}
    }),
    computed: {
      applicationTypes: function () {
        return [this.$t("application.individual"), this.$t("application.tandem"), this.$t("application.relay")]
          .map((e, i)=>{return {id: i, name: e}})
      },
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      }
    },
    props: {
      source: String
    },
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VDataTable,
      VTextarea,
      VAutocomplete,
      VCheckbox,
      VAlert,
      VDialog
    },
    methods: {
      show: function(obj){
        this.model = JSON.parse(JSON.stringify(obj));
        this.dialog = true;
      },
      save: function(){
        if(this.model.id != undefined){
          console.log("save "+this.model.id)
          fccapi.post(`categories/${this.model.id}`, this.model).then(d => {
            this.$store.dispatch('loadBaseData').then(e => {
              console.log("Base data loaded")
              this.dialog = false;
            }).catch(() => {
              console.log("Couldn't load base data")
            })
          }).catch(e => {
            console.log(e)
          })
        }else{
          this.model.CompetitionId = this.$store.getters.competitionId
          fccapi.post(`categories`, this.model).then(d => {
            this.$store.dispatch('loadBaseData').then(e => {
              console.log("Base data loaded")
              this.dialog = false;
            }).catch(() => {
              console.log("Couldn't load base data")
            })
          }).catch(e => {
            console.log(e)
          })
        }
      }
    },
    mounted: function(){
      
    }
  }
</script>